export const formFillsInclude = 'formAttributes,user';

export const formFillsQueryBase = {
	_limit: '20',
	_sort: '-createdAt',
	formId: 2,
};
